import React, { useState } from 'react'
import { makeStyles, CircularProgress } from '@zn-material-ui'

const styles = makeStyles({
  root: {
    position: 'absolute',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    zIndex: 99999,
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
  },
  progress: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    marginLeft: '-20px',
    marginTop: '-20px',
  },
})

export interface ILoadingProps {
  setLoading: (visible: boolean) => void
  getData: (d: Promise<any>) => Promise<any>
  getLoading: () => boolean
}
const enhanceLoading = <P extends ILoadingProps>(
  Comp: React.ComponentType<P>
) => (props: Omit<P, keyof ILoadingProps>) => {
    const getData = async (mayBePromise: Promise<any>) => {
      setLoading(true)
      try {
        const result = await mayBePromise
        setLoading(false)
        return result
      } catch (error) {
        setLoading(false)
      }
    }
    const classes = styles()
    const [loading, setLoading] = useState(false)
    const getLoading = () => loading
    return (
      <React.Fragment>
        {loading ? (
          <div className={classes.root}>
            <CircularProgress className={classes.progress} />
          </div>
        ) : null}
        <Comp
          {...(props as P)}
          setLoading={setLoading}
          getData={getData}
          getLoading={getLoading}
        />
      </React.Fragment>
    )
  }

export default enhanceLoading
